module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "elationemr-blue-logo.14c63530.png";